import { CurrencyCheck } from './currency-check';

export function TotalWithCurrencyCheck( toTotal: { amount: number, currency: any }[] ): number {
   if ( !CurrencyCheck( toTotal )) { return; }

   return toTotal.map( v => v.amount )
      .reduce(( a, c ) => a + c, 0 );
}
